import { httpRequest } from "@/axios/axios-api";

export default {
  data() {
    return {
      examRecordList: []
    };
  },
  created: function() {
    // 加载发票记录
    this.loadExamRecordList();
  },
  methods: {
    // 加载考试记录列表
    async loadExamRecordList() {
      const loadingInstance = this.$loading({ text: "加载中" });
      const res = await httpRequest("/app/exam/exam/exams", "get", null);
      if (res !== null && res !== undefined && res.code === 200) {
        this.examRecordList = res.data;
      }
      loadingInstance.close();
    },
    getExamRecordStatus(examRecordIdx) {
      let status = "-";
      const examRecord = this.examRecordList[examRecordIdx];
      if (examRecord.apply.examType === 0) {
        // 初次考试
        // 理论考试是否已通过
        if (examRecord.score >= examRecord.passScore) {
          // 通过了理论，看论文
          if (examRecord.apply.isCheckPass === 0) {
            if (
              examRecord.apply.paperUrl === null ||
              examRecord.apply.paperUrl === undefined ||
              examRecord.apply.paperUrl.length === 0
            ) {
              status = "等待上传论文";
            } else {
              status = "论文审核中";
            }
          } else if (examRecord.apply.isCheckPass === 1) {
            status = "论文未通过审核";
          } else if (examRecord.apply.isCheckPass === 2) {
            if (
              examRecord.apply.isPracticePass === 0 ||
              examRecord.apply.isPracticePass === null
            ) {
              status = "等待实践分";
            } else if (examRecord.apply.isPracticePass === 1) {
              status = "实践未通过";
            } else if (examRecord.apply.isPracticePass === 2) {
              status = "已通过考试";
            }
          }
        } else {
          status = "未通过理论考试";
        }
      } else {
        // 换证考试
        if (examRecord.score >= examRecord.passScore) {
          status = "已通过考试";
        } else {
          status = "未通过考试";
        }
      }
      return status;
    },
    go2ExamDetailPage(examRecordIdx) {
      const examRecord = this.examRecordList[examRecordIdx];
      this.$router.push({
        path: "/formalExam",
        query: {
          ftId: examRecord.ftId
        }
      });
    }
  }
};
